<div class="content">
  <div class="title">Errors console</div>
  <div class="error-container">
    @for (error of errors; track error) {
      <div>
        {{ error.message }}: {{ error.originalMessage }} ({{ error.code }})
      </div>
    }
  </div>
  <div class="buttons">
    <input type="button" (click)="ignoreAll()" value="Ignore all">
    <input type="button" (click)="clear()" value="Clear">
    <input type="button" (click)="close()" value="Close">
  </div>
</div>
